<template>
    <div class="dashboard_container cn_subscription_dashboard">
        <template v-if="isSwitchingPlan">
            <template v-if="isSubscriptionChanged">
                <div class="tfa-dashboard-section cn-dashboard-section">
                    <div class="top-section row">
                        <div class="dashboard-row stream-section col-12">
                            <div>
                                <div class="card">
                                    <div class="card-body text-center mt-5">
                                        <h4>{{switchPlanMessage}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tfa-dashboard-section cn-dashboard-section">
                    <div class="top-section row">
                        <div class="dashboard-row stream-section col-12">
                            <div>
                                <div class="card">
                                    <div class="card-body text-center mt-5">
                                        <h4>Your transaction was not successful. You will be redirected on subscription page in few seconds.</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="tfa-dashboard-section cn-dashboard-section">
                <div class="top-section row">
                    <div class="dashboard-row stream-section col-12">
                        <div>
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 subscription_sec">
                                            <b-card title="Premium Tier">
                                                <b-card-text class="plan_details">
                                                    <p>30 min Intro Call - No charge</p>
                                                    <p>30 min Call 2x/month</p>
                                                    <p>Unlimited messaging with coach</p>
                                                </b-card-text>

												<div class="plan_cost">$159.99 per month</div>
                                                <template v-if="isCancelAtPeriodEnd">
                                                    <template v-if="planType === 'Premium Tier'">
                                                        <b-button variant="primary" @click="cancelOrReactivateSubscription(false)">re-activate Plan</b-button>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="planType === 'Premium Tier'">
													    <span class="current_plan">current plan</span>
                                                    </template>
                                                    <template v-if="planType === 'Gold Tier'">
                                                        <b-button variant="primary" @click="upgradeDowngradeSubscription('premium')">downgrade</b-button>
                                                    </template>
                                                    <template v-if="planType === 'Platinum Tier'">
                                                        <b-button variant="primary" @click="upgradeDowngradeSubscription('premium')">downgrade</b-button>
                                                    </template>
                                                    <template v-if="planType === 'none'">
                                                        <b-button variant="primary" @click="subscriptionSetup('premium')">buy</b-button>
                                                    </template>
                                                </template>
                                            </b-card>
                                        </div>

                                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 subscription_sec">
                                            <b-card title="Gold Tier">
                                                <b-card-text class="plan_details">
                                                    <p>30 min Intro Call - No charge</p>
                                                    <p>30 min Call 4x/month</p>
                                                    <p>Unlimited messaging with coach</p>
                                                </b-card-text>
												<div class="plan_cost">$299.99 per month</div>
                                                <template v-if="isCancelAtPeriodEnd">
                                                    <template v-if="planType === 'Gold Tier'">
                                                        <b-button variant="primary" @click="cancelOrReactivateSubscription(false)">re-activate</b-button>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="planType === 'Premium Tier'">
                                                        <b-button variant="primary" @click="upgradeDowngradeSubscription('gold')">upgrade</b-button>
                                                    </template>
                                                    <template v-if="planType === 'Gold Tier'">
													     <span class="current_plan">current plan</span>
                                                    </template>
                                                    <template v-if="planType === 'Platinum Tier'">
                                                        <b-button variant="primary" @click="upgradeDowngradeSubscription('gold')">downgrade</b-button>
                                                    </template>
                                                    <template v-if="planType === 'none'">
                                                        <b-button variant="primary" @click="subscriptionSetup('gold')">buy</b-button>
                                                    </template>
                                                </template>
                                            </b-card>
                                        </div>

                                        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 subscription_sec">
                                          <b-card title="Platinum Tier">
                                                <b-card-text class="plan_details">
                                                    <p>30 min Intro Call - No charge</p>
                                                    <p>50 min Call 4x/month</p>
                                                    <p>Unlimited messaging with coach</p>
                                                </b-card-text>
												<div class="plan_cost">$499.99 per month</div>
                                                <template v-if="isCancelAtPeriodEnd">
                                                    <template v-if="planType === 'Platinum Tier'">
                                                        <b-button variant="primary" @click="cancelOrReactivateSubscription(false)">re-activate Plan</b-button>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="planType === 'Premium Tier'">
                                                        <b-button variant="primary" @click="upgradeDowngradeSubscription('platinum')">upgrade</b-button>
                                                    </template>
                                                    <template v-if="planType === 'Gold Tier'">
                                                        <b-button variant="primary" @click="upgradeDowngradeSubscription('platinum')">upgrade</b-button>
                                                    </template>
                                                    <template v-if="planType === 'Platinum Tier'">
													    <span class="current_plan">current plan</span>
                                                    </template>
                                                    <template v-if="planType === 'none'">
                                                        <b-button variant="primary" @click="subscriptionSetup('platinum')">buy</b-button>
                                                    </template>
                                                </template>
                                            </b-card>
                                        </div>
                                    </div>

								  <div class="cancel_plan" v-if="!isCancelAtPeriodEnd && (planType !== 'none')">
								     <span>If you want to cancel the plan click</span>
									  <b-button variant="primary" @click="cancelOrReactivateSubscription(true)">cancel plan</b-button>
								  </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="loading-spinner">
            <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF; overflow: hidden;">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
	/* global Stripe:true */
	import { mapActions } from 'vuex'
	import { DateTime } from 'luxon'
	import '../../../assets/module/css/dashboard/tfaDashboard.min.css'

	export default {
	  name: 'clearly-next-student-subscription',
	  props: ['uuid', 'checkoutSessionId'],
	  data: () => {
	    return {
	      sessionId: '',
	      stripePublishKey: '',
	      planType: '',
	      subscriptionId: '',
	      isSwitchingPlan: false,
	      isSubscriptionChanged: false,
	      isCanceled: false,
	      isCancelAtPeriodEnd: false,
	      switchPlanMessage: ''
	    }
	  },

	  mounted () {
	    /* TODO: Uncomment when calling subscription checkout directly
	    if (this.checkoutSessionId) {
	      this.getSubscriptionDetail({uuid: this.uuid, sessionId: this.checkoutSessionId})
	    } else {
          this.getSubscriptionDetail({uuid: this.uuid})
	    }
	    */
	    this.getSubscriptionDetail()
	  },

	  methods: {
	    ...mapActions([
	      /* 'loadSubscriptionCheckout', */
	      'loadStripeSubscriptionSetup',
	      'loadStripeSubscriptionDetail',
	      'loadChangeStripeSubscription',
	      'loadCancelOrReactivateStripeSubscription'
	    ]),

	    /*
	    subscriptionCheckout (plan) {
	      this.showLoader()
          this.loadSubscriptionCheckout(plan).then(res => {
            this.hideLoader()
            this.sessionId = res.sessionId
            this.stripePublishKey = res.stripePublishKey
            let stripe = Stripe(this.stripePublishKey)
            stripe.redirectToCheckout({
              sessionId: this.sessionId
            }).then((result) => {
              if (result.error) {
                console.log(result.error.message)
              }
            })
          })
        },
        */

	    subscriptionSetup (plan) {
	      this.showLoader()
	      this.loadStripeSubscriptionSetup(plan).then(res => {
	        this.hideLoader()
	        this.sessionId = res.sessionId
	        this.stripePublishKey = res.stripePublishKey
	        let stripe = Stripe(this.stripePublishKey)
	        stripe.redirectToCheckout({
          sessionId: this.sessionId
        }).then((result) => {
          if (result.error) {
            console.log(result.error.message)
          }
        })
	      })
	    },

	    getSubscriptionDetail () {
	      this.planType = ''
	      this.loadStripeSubscriptionDetail({uuid: this.uuid}).then(res => {
	        if (res) {
	          this.planType = res.planType
	          this.subscriptionId = res.subscriptionId
	          this.isCanceled = res.isCanceled
	          this.isCancelAtPeriodEnd = res.isCancelAtPeriodEnd
	          // console.log('subscription: ', res.subscription)
	        } else {
	          this.planType = 'none'
	        }
	      })
	    },

	    upgradeDowngradeSubscription (plan) {
	      this.showLoader()
	      this.loadChangeStripeSubscription(plan).then(res => {
	        this.isSubscriptionChanged = !!(res)
	        this.switchPlanMessage = 'You have successfully changed your plan to "' + res.planType + '" .You will be redirected on subscription page in few seconds.'
	        this.isSwitchingPlan = true
	        this.hideLoader()
	        setTimeout(() => {
	          this.isSwitchingPlan = false
	          this.isSubscriptionChanged = false
	          this.getSubscriptionDetail()
	        }, 5000)
	      })
	    },

	    cancelOrReactivateSubscription (cancelOrReactivate) {
	      this.showLoader()
      this.loadCancelOrReactivateStripeSubscription(cancelOrReactivate).then(res => {
        this.isSubscriptionChanged = !!(res)
        if (cancelOrReactivate) {
          this.switchPlanMessage = 'Your plan will cancel automatically at end of the period, "' + this.changeMillisToDate(res.cancelAtMillis) + '". You will be redirected on subscription page in few seconds.'
        } else {
          this.switchPlanMessage = 'You have successfully reactivated your "' + res.planType + '" plan. You will be redirected on subscription page in few seconds.'
        }
        this.isSwitchingPlan = true
        this.hideLoader()
        setTimeout(() => {
          this.isSwitchingPlan = false
          this.isSubscriptionChanged = false
          this.getSubscriptionDetail()
        }, 5000)
      })
	    },

	    changeMillisToDate (millis) {
      let formattedDate = DateTime.fromMillis(millis, {zone: 'America/New_York'}).toFormat('LLL dd, h:mm a')
      return formattedDate
    },

	    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },

    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    }
	  }
	}
</script>

<style scoped>
<style>



// WEBPACK FOOTER //
// src/app/user/components/ClearlyNextStudentSubscription.vue